module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tabbar/theme/lui-tab.global.scss
// module id = 345
// module chunks = 0 1 6